export const vvvoRegExp = /^[0-9]{3}[ ]?[0-9]{2}[ ]?[0-9]{3}[ ]?[0-9]{3}[ ]?[0-9]{4}$/;
export const vvvoRegExpGroup = /^([0-9]{3})[ ]?([0-9]{2})[ ]?([0-9]{3})[ ]?([0-9]{3})[ ]?([0-9]{4})$/;

export const formatVvvoNummer = (vvvoNummer: string): string => {
    const groups = Array.from(vvvoRegExpGroup.exec(vvvoNummer) || []);
    groups.shift();
    return groups.join(' ');
};
